/**
 * Angular imports.
 */
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

/**
 *
 */
@Component({
  selector: 'app-time-picker',
  templateUrl: './time-picker.component.html',
  styleUrls: ['./time-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TimePickerComponent {

  /**
   *
   */
  @Input() time: Date;
  @Input() minTime: Date;
  @Input() maxTime: Date;
  @Input() isDisabled: boolean;
  @Input() disabledKeyBoard: boolean;
  @Input() placeholder: string;

  /**
   *
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Output() emitSetTime: EventEmitter<any> = new EventEmitter();


  /**
   *
   */
  setTime(time): void {
    this.emitSetTime.emit(time);
  }
}
